import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as THEMES from '../themes';
import * as _ from 'lodash';

@Injectable()
export class ThemeSwitcherService {

  private currentTheme;
  className = 'ThemeSwitcherService';

  constructor(private http: HttpClient) {

  }

  changeTheme(theme) {
    const stylesheet: any = this.getStylesheet(theme);
    this.applyThemeVariables(stylesheet);
    this.currentTheme = theme;
  }

  private applyThemeVariables(variables: Record<string, string>) {
    const root = document.documentElement;
    Object.entries(variables).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
  }

  getStylesheet(theme) {
    return THEMES[theme];
  }

  getCurrentTheme() {
    return THEMES[this.currentTheme];
  }
}
